function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchresultAlertError = function SvgLivemapSearchresultAlertError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.702,
    height: 19.23,
    viewBox: "0 0 19.702 19.23"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 4595",
    style: {
      fill: "none"
    },
    transform: "translate(2.003 1.294)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 11756",
    style: {
      fill: "#d93a5b"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.052 16.955H1.641A2.58 2.58 0 0 1-.581 15.68a2.625 2.625 0 0 1-.081-2.602l6.24-11.913c.47-.89 1.367-1.44 2.34-1.44.972 0 1.868.55 2.337 1.436l.002.004.002.004 6.168 11.91a2.604 2.604 0 0 1-.079 2.58 2.654 2.654 0 0 1-2.296 1.296z",
    style: {
      stroke: "none"
    },
    transform: "translate(1.969 1.275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.052 15.955c1.277 0 2.057-1.347 1.49-2.411L9.371 1.629c-.639-1.205-2.27-1.205-2.908 0L.223 13.544c-.568 1.064.212 2.411 1.418 2.411h12.411m-7.163-3.9h1.986v1.773H6.889v-1.773m-.07-6.596h2.056l-.213 5.46H7.031l-.213-5.46m7.234 12.496H1.641a3.571 3.571 0 0 1-3.08-1.761 3.617 3.617 0 0 1-.107-3.583L4.696.693C5.339-.52 6.573-1.275 7.917-1.275c1.345 0 2.58.754 3.222 1.968l.008.017 6.166 11.906a3.596 3.596 0 0 1-.107 3.557 3.646 3.646 0 0 1-3.154 1.782z",
    style: {
      fill: "#fff",
      stroke: "none"
    },
    transform: "translate(1.969 1.275)"
  })));
};
export default SvgLivemapSearchresultAlertError;